


export const CLIENT_CODE_LABEL = 'clientcode'
export const CLIENT_CODE_LABEL_NAME = 'anew'

export const TRMRoles = {
    sales: 'TRM Sales',
    inbound: 'TRM Inbound',
    outbound: 'TRM Outbound',
    processor: 'TRM Processor',
    admin: 'TRM Admin',
    superadmin: 'TRM Super Admin',
    siteadmin:'Admin',
    customer:'TRM Customer'
}
export const TRMUserManagementRoles = {
  customer: 'Customer',
  anewTeam: 'Anew Team',
  processor: 'Processor',
}

export const TRMBuildModifiedListColumns = {
  eKey: 'eKey',
  eTag: 'eTag',
  Name: 'Name',
  BuildVersion: 'BuildVersion',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
}

export const TRMHistoryListSelectColumns = {
  eKey: 'eKey',
  eTag: 'eTag',
  InquiryID: 'InquiryID',
  InquiryGUID: 'InquiryGUID',
  StatusCode: 'StatusCode',
  PreviousStatusCode: 'PreviousStatusCode',
  Action: 'Action',
  UserRole: 'UserRole',
  Comment:'Comment',
  'Status/StatusDescription': 'Status/StatusTitle',
  'PreviousStatus/StatusDescription': 'PreviousStatus/StatusTitle',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
};
export const TRMDiscussionsListSelectColumns = {
  eKey: 'eKey',
  eTag: 'eTag',
  InquiryDiscussionsGUID: 'InquiryDiscussionsGUID',
  InquiryID: 'InquiryID',
  InquiryGUID: 'InquiryGUID',
  Subject: 'Subject',
  Comment: 'Comment',
  IsActionComment: 'IsActionComment',
  ParentCommentCode: 'ParentCommentCode',
  UserRole: 'UserRole',
  CommentType: 'CommentType',
  CommentDocumentName: 'CommentDocumentName',
  DocumentName: 'DocumentName',
    ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
};

export const TRMAccountMetadataListSelectColumns = {
  AccountID: "AccountID",
  eKey: 'eKey',
  eTag: 'eTag',
  Name: 'Name',
  FEINNumber:'FEINNumber',
  StreetName: 'StreetName',
  Unit: 'Unit',
  City: 'City',
  County: 'County',
  State: 'State',
  ZipCode: 'ZipCode',
  AccOwnerID:'AccOwnerID',
  IsArchived: 'IsArchived',
  Email: 'Email',
  PhoneNumber: 'PhoneNumber',
  POC: 'POC',
  ItemCreated: 'ItemCreated',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  ItemCreatedBy: 'ItemCreatedBy',
  IsDeleted: 'IsDeleted',
  SpecialInstructions:'SpecialInstructions',
  PlateType:'PlateType'
};


export const TRMSubClientSettingMetadataListColumns = {
  SID:"SID",
  eKey: 'eKey',
  eTag: 'eTag',
  SubClient: 'SubClient',
  SubClientID: 'SubClientID',
  subOwnerID:'subOwnerID',
  AccountID:'AccountID',
  FEINNumber:'FEINNumber',
  StreetName: 'StreetName',
  Unit: 'Unit',
  City: 'City',
  County: 'County',
  State: 'State',
  ZipCode: 'ZipCode',
  IsArchived: 'IsArchived',
  Email: 'Email',
  PhoneNumber: 'PhoneNumber',
  POC: 'POC',
  ItemCreated: 'ItemCreated',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  ItemCreatedBy: 'ItemCreatedBy',
  IsDeleted: 'IsDeleted',
  SpecialInstructions:'SpecialInstructions',
  PlateType:'PlateType'
};
export const TRMAccTaxExemptionListColumns={

  eKey:'eKey',
  eTag:'eTag',
  AccTaxExemptNumber:'AccTaxExemptNumber',
  AccountID:'AccountID',
  AccTaxExemptState:'AccTaxExemptState',
  ItemCreated:'ItemCreated',
  ItemModified:'ItemModified',
  ItemModifiedBy:'ItemModifiedBy',
  ItemCreatedBy:'ItemCreatedBy',
  IsDeleted:'IsDeleted'
}
export const TRMSubClientTaxExemptionListColumns={
  eKey:'eKey',
  eTag:'eTag',
  subClientTaxExemptNumber:'subClientTaxExemptNumber',
  subclientTaxExemptState:'subclientTaxExemptState',
  SID:'SID',
  ItemCreated:'ItemCreated',
  ItemModified:'ItemModified',
  ItemModifiedBy:'ItemModifiedBy',
  ItemCreatedBy:'ItemCreatedBy',
   IsDeleted: 'IsDeleted',
}
export const InquiryViewColumns = {
  InquiryID: "InquiryID",
  AccCity: "AccCity",
  AccCounty: "AccCounty",
  AccName: "AccName",
  AccState: "AccState",
  AccStreetName: "AccStreetName",
  AccUnit: "AccUnit",
  AccZipCode: "AccZipCode",
  AdditionalInformation: "AdditionalInformation",
  AnewAccOwnerID: "AnewAccOwnerID",
  AnewAccountOwner: "AnewAccountOwner",
  ArchivedDate: "ArchivedDate",
  AssignedProcessor: "AssignedProcessor",
  CanceledDate: "CanceledDate",
  Color: "Color",
  CompletedDate: "CompletedDate",
  County: "County",
  Email: "Email",
  FEINNumber: "FEINNumber",
  FuelType: "FuelType",
  GrossVehicleWeight: "GrossVehicleWeight",
  ID: "ID",
  InquiryGUID: "InquiryGUID",
  InquiryeKey: "InquiryeKey",
  InquiryeTag: "InquiryeTag",
  IsArchived: "IsArchived",
  IsDeleted: "IsDeleted",
  IsInboundActionRequired: "IsInboundActionRequired",
  IsMigrated: "IsMigrated",
  IsPendingProblem: "IsPendingProblem",
  IsRegAndTitleDetailsSame: "IsRegAndTitleDetailsSame",
  IsRequestForCancelation: "IsRequestForCancelation",
  IsSalesRequired: "IsSalesRequired",
  IsWorkOrder: "IsWorkOrder",
  ItemCreated: "ItemCreated",
  ItemCreatedBy: "ItemCreatedBy",
  ItemModified: "ItemModified",
  ItemModifiedBy: "ItemModifiedBy",
  LicensePlateNumber: "LicensePlateNumber",
   LienDate: "LienDate",
  LienHolderAddress: "LienHolderAddress",
  LienHolderName: "LienHolderName",
  LienHolderNumber: "LienHolderNumber",
  Make: "Make",
  Model: "Model",
  Odometer: "Odometer",
  OwnershipType: "OwnershipType",
  PolicyHolder: "PolicyHolder",
  PolicyNumber: "PolicyNumber",
  PhoneName: "PhoneName",
  PlateType: "PlateType",
  PointOfContact: "PointOfContact",
  PreviousStatusCode: "PreviousStatusCode",
  ProblemTitle: "ProblemTitle",
  ProcessType: "ProcessType",
  RegCity: "RegCity",
  RegCounty: "RegCounty",
  RegExpirationDate: "RegExpirationDate",
  RegName: "RegName",
  RegState: "RegState",
  RegStreetname: "RegStreetname",
  RegUnit: "RegUnit",
  RegZipCode: "RegZipCode",
  RejectedDate: "RejectedDate",
  ShippingAddress: "ShippingAddress",
  State: "State",
  StateTaxExemptAssociation: "StateTaxExemptAssociation",
  StatusCode: "StatusCode",
  StatusTitle: "StatusTitle",
  SubClientName: "SubClientName",
  SubClientTaxExemptionNumber: "SubClientTaxExemptionNumber",
  SubmittedDate: "SubmittedDate",
  TaxExempt: "TaxExempt",
  TeamMembers: "TeamMembers",
  Territory: "Territory",
  TMSID: "TMSID",
  TitleCity: "TitleCity",
  TitleCounty: "TitleCounty",
  TitleName: "TitleName",
  TitleState: "TitleState",
  TitleUnit: "TitleUnit",
  TitleZipCode: "TitleZipCode",
  TitlestreetName: "TitlestreetName",
  TitleNumber: "TitleNumber",
  Trim: "Trim",
  VID: "VID",
  VINNumber: "VINNumber",
  EmptyVehicleWeight: "EmptyVehicleWeight",
  ExpirationDate: "ExpirationDate",
  InsuranceAddress: "InsuranceAddress",
  InsuranceCompanyName: "InsuranceCompanyName",
  InsurancePhoneNumber: "InsurancePhoneNumber",
  VehicleType: "VehicleType",
  VehicleUnitNumber: "VehicleUnitNumber",
  VehicleeKey: "VehicleeKey",
  VehicleeTag: "VehicleeTag",
  WorkOrderCreated: "WorkOrderCreated",
  Year: "Year",
  "Status/StatusTitle":"Status/StatusTitle",
  ETCDate:"ETCDate",
  ModifiedOn:"ItemModifiedOn",
  IsRenewal: "IsRenewal",
  ItemModifiedOn:"ItemModifiedOn",
  ActionComment:'ActionComment',
  Lien: "Lien"
}

export const TRMBulkImportTemplateListSelectColumns = {
  eKey: 'eKey',
  eTag: 'eTag',
  TemplateName: 'TemplateName',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
};
export const TRMTrackingNumberListColumns = {
  eKey: 'eKey',
  eTag: 'eTag',
  InquiryID: 'InquiryID',
  InquiryGUID: 'InquiryGUID',
  Comment: 'Comment',
  TrackingNumber: 'TrackingNumber',
  TrackingURL: 'TrackingURL',
  ShipmentCarrier: 'ShipmentCarrier',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
};
export const TRMInquiryListSelectColumns = {
    ID: 'ID',
    ekey: 'eKey',
    eTag: 'eTag',
    InquiryID: 'InquiryID',
    InquiryGUID: 'InquiryGUID',
    AccName: 'AccName',
    SubClientName: 'SubClientName',
    PointOfContact: 'PointOfContact',
    FEINNumber:'FEINNumber',
    AccStreetName: 'AccStreetName',
    AccUnit: 'AccUnit',
    AccCity: 'AccCity',
    AccCounty: 'AccCounty',
    AccState: 'AccState',
    // AccTerritory:'AccTerritory',
    Territory:'Territory',
    County:'County',
    State:'State',
    AccZipCode: 'AccZipCode',
    Email: 'Email',
    Lien: 'Lien',
    PhoneName: 'PhoneName',
    AnewAccountOwner: 'AnewAccountOwner',
    IsRegAndTitleDetailsSame: 'IsRegAndTitleDetailsSame',
    ProcessType: 'ProcessType',
    RegName: 'RegName',
    RegStreetname: 'RegStreetname',
    AnewAccOwnerID:'AnewAccOwnerID',
    RegUnit: 'RegUnit',
    RegCity: 'RegCity',
    RegCounty: 'RegCounty',
    RegState: 'RegState',
    RegZipCode: 'RegZipCode',
    TitleName: 'TitleName',
    TitlestreetName: 'TitlestreetName',
    TitleUnit: 'TitleUnit',
    TitleCity: 'TitleCity',
    TitleCounty: 'TitleCounty',
    TitleState: 'TitleState',
    TitleZipCode: 'TitleZipCode',
    VINNumber: 'VINNumber',
   AssignedProcessor:'AssignedProcessor',
    AdditionalInformation: 'AdditionalInformation',
    StatusCode: 'StatusCode',
    PreviousStatusCode: 'PreviousStatusCode',
    'Status/StatusTitle': 'Status/StatusTitle',
    'PreviousStatus/StatusTitle': 'PreviousStatus/StatusTitle',
    SubmittedDate: 'SubmittedDate',
    RejectedDate: 'RejectedDate',
    CanceledDate: 'CanceledDate',
    IsArchived: 'IsArchived',
    ItemCreated: 'ItemCreated',
    ItemCreatedBy: 'ItemCreatedBy',
    ItemModified: 'ItemModified',
    ItemModifiedBy: 'ItemModifiedBy',
    IsWorkOrder:'IsWorkOrder',
    WorkOrderCreated:'WorkOrderCreated',
    IsSalesRequired: 'IsSalesRequired',
    IsInboundActionRequired: 'IsInboundActionRequired',
    IsPendingProblem: 'IsPendingProblem',
    ProblemTitle: 'ProblemTitle',
    CompletedDate:'CompletedDate',
    ETCDate:'ETCDate',
    TMSID:'TMSID'
    //IsRequestForCancelation:'IsRequestForCancelation',
}

export const TRMExportInquiryColumns = {
  ID: "ID",
  InquiryGUID: "InquiryGUID",
  ProblemTitle:'ProblemTitle',
  ActionComment:'ActionComment',
  IsPendingProblem:'IsPendingProblem',
  AccName: "AccName",
  SubClientName: "SubClientName",
  TaxExemptNo: "TaxExemptNo",
  State: "State",
  County: "County",
  ProcessType: "ProcessType",
  ItemModified: "ItemModified",
  SubmittedDate: "SubmittedDate",
  WorkOrderCreated: "WorkOrderCreated",
  AnewAccountOwner: "AnewAccountOwner",
  AnewAccOwnerID: "AnewAccOwnerID",
  TeamMembers: "TeamMembers",
  OwnershipType: "OwnershipType",
  AssignedProcessor: "AssignedProcessor",
  ItemCreatedBy: "ItemCreatedBy",
  StatusTitle: "StatusTitle",
  IsSalesRequired: "IsSalesRequired",
  IsInboundActionRequired: "IsInboundActionRequired",
  IsRequestForCancelation: "IsRequestForCancelation",
  VINNumber: "VINNumber",
  VehicleUnitNumber: "VehicleUnitNumber",
  Year: "Year",
  Make: "Make",
  Model: "Model",
  Trim: "Trim",
  FuelType: "FuelType",
  GrossVehicleWeight: "GrossVehicleWeight",
  EmptyVehicleWeight: "EVW",
  LicensePlateNumber: "LicensePlateNumber",
  RegExpirationDate: "RegExpirationDate",
  TitleNumber: "TitleNumber",
  TitleState: "TitleState",
  LienHolderName: "LienHolderName",
  LienHolderAddress: "LienHolderAddress",
  LienHolderNumber: "LienHolderNumber",
  LienDate: "LienDate",
  PolicyHolder: "PolicyHolder",
  PolicyNumber: "PolicyNumber",
  ExpirationDate: "ExpirationDate",
  InsuranceCompanyName: "InsuranceCompanyName",
  InsuranceStreetName: "InsuranceStreetName",
  InsurancePhoneNumber: "InsurancePhoneNumber",
  ShippingStreetName: "ShippingStreetName",
  LienHolderStreetName: "LienHolderStreetName",
  TrackingNumber: "TrackingNumber",
  Comment: "Comment",
  IsDeleted:"IsDeleted",
  IsArchived:"IsArchived",
  IsWorkOrder:"IsWorkOrder",
  StatusCode: "StatusCode",
  Territory: "Territory",
  ETCDate: "ETCDate",
  TMSID: "TMSID",
  VehicleType: "VehicleType",
  TaxExempt:'TaxExempt',
  Odometer:'Odometer',
  Color:'Color',
  PlateType:'PlateType',
  PhoneName:'PhoneName',
  Lien:'Lien',
  AdditionalInformation:'AdditionalInformation',
  FEINNumber:'FEINNumber',
  PointOfContact:'PointOfContact',
  Email:'Email',
  ArchivedDate:'ArchivedDate',
  CompletedDate:'CompletedDate',
  CanceledDate:'CanceledDate',
  modifiedOn:'modifiedOn',
  DriverName:"DriverName",
  DriverEmail:"DriverEmail",
  DriverPhone:"DriverPhone",
  DriverStreetName:'DriverStreetName'
}
export const TRMDriverInformationListSelectColumns = {
  eKey: 'eKey',
  eTag: 'eTag',
  InquiryGUID: 'InquiryGUID',
  Name: 'Name',
  Email: 'Email',
  PhoneNumber: 'PhoneNumber',
  StreetName: 'StreetName',
  Unit: 'Unit',
  County: 'County',
  ZipCode: 'ZipCode',
  City: 'City',
  State: 'State',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy'
}
export const TRMAdditionalInformationListSelectColumns = {
  eKey: 'eKey',
  eTag: 'eTag',
  InquiryGUID: 'InquiryGUID',
  InsuranceCompanyName: 'InsuranceCompanyName',
  PolicyNumber: 'PolicyNumber',
  PolicyHolder: 'PolicyHolder',
  PolicyExpiryDate: 'PolicyExpiryDate',
  InsurancePhoneNumber: 'InsurancePhoneNumber',
  InsuranceStreetName: 'InsuranceStreetName',
  InsuranceUnit: 'InsuranceUnit',
  InsuranceCity: 'InsuranceCity',
  InsuranceCounty: 'InsuranceCounty',
  InsuranceState: 'InsuranceState',
  InsuranceZipCode: 'InsuranceZipCode',
  ShippingStreetName: 'ShippingStreetName',
  ShippingUnit: 'ShippingUnit',
  ShippingCity: 'ShippingCity',
  ShippingCounty: 'ShippingCounty',
  ShippingState: 'ShippingState',
  ShippingZipCode: 'ShippingZipCode',
  TitleState: 'TitleState',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy'
}





export const MAX_NUM_FILES = 10
export const CALENDAR_EVENT_MSG ='Are you sure, you want to delete this calendar event?'
export const NO_CHANGE_MSG ='No changes detected'
export const MAX_FILE_SIZE = 26214400 // 25 MB
export const ACCEPTABLE_FILE_TYPES = [
  'xlsx', 'XLSX', 'xls', 'XLS', 'doc', 'DOC', 'docx', 'DOCX',
  'txt', 'TXT', 'pdf', 'PDF', 'png', 'PNG', 'jpg', 'JPG', 'jpeg', 'JPEG',
]
export const FILE_CHARACTERS_UNALLOWED = [',', '!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '+', '=', '[', ']', '{', '}', 'ʻ', ':', '“', '|', '<', '>', '/', '?', '~']
export const ListNames = {
  TRMAdditionalInformationList:'TRMAdditionalInformationList',
  TRMBulkUploadList:'TRMBulkUploadList',
  TRMTeamMembersList:'TRMTeamMembersList',
  TRMAccountSettingMetadataList:'TRMAccountSettingMetadataList',
  InquiryList : 'TRMInquiryList',
  TRMBuildModifiedList:'TRMBuildModifiedList',
  InquiryHistList :'TRMInquiryHistoryList',
  TRMNotificationsMetadataList:'TRMNotificationsMetadataList',
  TRMActvityLogMetadataList:'TRMActvityLogMetadataList',
  InquiryDussionsList :'TRMInquiryDiscussionsList',
  ChecktsListMetadataList:'TRMChecklistsListMetadataList',
  POLICY_MEMO: 'PolicyMemoAndGuidelinesList',
  TRMProcessFlowMetadataList: 'TRMProcessFlowMetadataList',
  TRMStatusMetadataList:'TRMStatusMetadataList',
  TRMTooltipMetadataList:'TRMTooltipMetadataList',
  TRMCommonMetadataList:'TRMCommonMetadataList',
  TRMCountyMetadataList:'TRMCountyMetadataList',
  CustomerFormCheckList: 'TRMCustomerFormCheckList',
  StateFormCheckList: 'TRMStateFormCheckList',
  CheckList: 'TRMCheckList',
  TRMTrackingNumberList:'TRMTrackingNumberList',
  InspectionFormCheckList:'TRMInspectionFormCheckList',
  TRMNotificationsList:'TRMNotificationsList',
  TRMFormCheckListMetadata:'TRMFormCheckListMetadata',
  TRMQandAList:'TRMFAQList',
  TRMAnnouncementList:'TRMAnnouncementsList',
  TRMKnowledgeGraphList:'TRMKnowledgeGraphList',
  TRMMasterActvityLogList:'TRMMasterActvityLogList',
  TRMSiteFeedbackList:'TRMSiteFeedbackList',
  TRMFeedbackAboutList:'TRMFeedbackAboutList',
  TRMReleaseNotesList:'TRMReleaseNotesList',
  CALENDAR:'',
  TRMVehicleInformationList:'TRMVehicleInformationList',
  TRMDriverInformationList:'TRMDriverInformationList',
  V_TRAMInquiryList:'V_TRMInquiryList',
  TRMCalendarList:'TRMCalendarList',
 TRMBulkImportTemplateList:'TRMBulkImportTemplateList',
  V_ExportCSV_TRMInquiryList:'V_ExportCSV_TRMInquiryList',
  TRMSubClientSettingMetadataList:'TRMSubClientSettingMetadataList',
  TRMConfigurationList: 'TRMConfigurationList',
  TRMFeeCalculationList:'TRMFeeCalculationList',
  V_FeeCalculationList: 'V_FeeCalculationList',
  V_TRMInquiryHistoryList:'V_TRMInquiryHistoryList',
  TRMSubClientTaxExemptionList:'TRMSubClientTaxExemptionList',
  TRMAccTaxExemptionList:'TRMAccTaxExemptionList',

  
 
}
export const AnewTRMFolderPath = '/TRMInquiryList'
export const TRMTemplateFolderPath = '/TRMBulkImportTemplateList'
export const TRMBulkUploadListFolderPath = '/TRMBulkUploadList'
export const AnewTRMQandAFolderPath = '/TRMFAQList'
export const AnewTRMAnnouncementFolderPath = '/TRMAnnouncementsList'
export const AnewTRMKnowledgeGraphFolderPath = '/TRMKnowledgeGraphList'
export const AnewTRMSiteFeedbackFolderpath='/TRMSiteFeedbackList'
export const AnewTRMCalendarFolderPath='/TRMCalendarList'
export const GOOGLE_API_KEY = "AIzaSyCKV0tpyYzgC_MIgHWG-6OdXTopkYkDnxM"
export const StatusCode = {
  InquiryUpdated: 'Inquiry Updated',
  WorkOrderUpdated: 'Work Order Updated'
}

export const commonMetadataTypes = {
  FuelType: 'FuelType',
  OwnershipType: 'OwnershipType',
  ProcessType: 'ProcessType',
  Color: 'Color',
  VehicleType:'VehicleType',
  Territory:'Territory',
  State:'State',
  PlateType:'PlateType',
  CostType:'CostType'
}

export const RequiredDocuments =['Both','Registration','Title']
 
export const RoleCreatedBySystem="SystemInit"

export const CheckListTypes ={
  CustomerProvided:"Customer Provided",
  RequiredStateForms:"Required State Forms",
  InspectionStateForms:"Inspection State Forms"
}

export const TRMMasterActivityLogListSelectColumns = {
  InquiryID: 'InquiryID',
  InquiryGUID: 'InquiryGUID',
  Action: 'Action',
  Message: 'Message',
  IsWorkOrder: 'IsWorkOrder',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
};

export const UserRoles =['User','AppUser','TRM Processor']
export const UserRoleCodes =['User','AppUser','TRM-Processor']
export const restrictedEmails = ["dbloadersystem@rhybus.local","jobsystem@rhybus.local"];
export const displayKeys = ["Address", "AptNumber", "City", "County", "StateName", "ZIPCode"];
export const customerRoles = ["User", "AppUser"];
export const restrictedRoles = ["admin",
"user",
"appuser"];
export const restrictedAsignedRoles = ["admin",
"user",
"appuser","trm processor"];
export const IDB_ARCHIVED_INQUIRY_LIST_STORE = 'ArchivedInquiriesList'
export const IDB_INQUIRY_LIST_STORE = 'InquiriesList'
export const IDB_INQUIRY_LIST_KEYPATH = 'InquiryeKey'

export const CHAT_ID_PARAM = 'chat_id';
export const PENDING_CHAT_KEY = 'pending_shared_chat_id';
export const REDIRECT_KEY = 'shared_chat_redirect';

export const OtherFee='Other Fee'
